export type TypographyVariant =
  | 'hero'
  | 'title'
  | 'subtitle'
  | 'body'
  | 'bodyBold'
  | 'caption'
  | 'captionMuted'
  | 'error';

export const TYPOGRAPHY_VARIANT_STYLES: Record<TypographyVariant, string> = {
  hero: 'text-4xl font-bold leading-tight',
  title: 'text-3xl font-bold',
  subtitle: 'text-xl font-semibold',
  body: 'text-base text-gray-700',
  bodyBold: 'text-base font-semibold text-gray-800',
  caption: 'text-sm text-gray-500',
  captionMuted: 'text-sm text-gray-400',
  error: 'text-sm text-red-500',
};
